let isScriptLoaded = false;
const siteId = "g28s7j";
const cookieConsentBeacon = "analytics";
const cookieConsentInteliSuggest = "analytics";

function addScript() {
  return new Promise((resolve, reject) => {
    if (isScriptLoaded) {
      resolve(); // Return if script is already loaded
      return;
    }

    const scriptElement = document.createElement("script");
    scriptElement.src = "https://cdn.searchspring.net/intellisuggest/is.min.js";
    scriptElement.type = "text/javascript";
    scriptElement.setAttribute("hid", "search-spring-script");

    scriptElement.onload = () => {
      console.log("SEARCH SPRING TRACKING ONLOAD CALLED");
      isScriptLoaded = true;
      resolve(); // Resolve when script is loaded
    };

    scriptElement.onerror = () => {
      console.error("SEARCH SPRING SCRIPT failed to load");
      reject(new Error("Script failed to load"));
    };

    // Inject script into the head
    document.head.appendChild(scriptElement);
  });
}

export default function ({ app }, inject) {
  inject("searchspring", {
    async trackProductClick(el, intellisuggestData, intellisuggestSignature) {
      try {
        if (!app.$cookieConsent.isConsented(cookieConsentInteliSuggest)) {
          return;
        }

        await addScript();
        if (!window?.IntelliSuggest) {
          console.error("IntelliSuggest is not loaded");
          return;
        }

        window.IntelliSuggest.clickItem(el, {
          siteId,
          intellisuggestData,
          intellisuggestSignature,
        });
      } catch (err) {
        console.error("Error in product view tracking:", err);
        app.$bugsnag.notify(err);
      }
    },

    async trackProductView(productId, variantId, sku) {
      try {
        if (!app.$cookieConsent.isConsented(cookieConsentBeacon)) {
          return;
        }

        const uid = variantId ?? productId;
        const result = {
          parentId: String(productId),
          uid: String(uid),
          ...(sku && { sku }),
        };

        await app.$search.callBeacon2Api("product", "pageview", {
          result,
        });
      } catch (err) {
        console.error("Error in product view tracking:", err);
        app.$bugsnag.notify(err);
      }
    },

    async trackBasketView() {
      try {
        if (!app.$cookieConsent.isConsented(cookieConsentBeacon)) {
          return;
        }

        const lines = app.store.getters["bag/lines"] || [];
        const results = lines.map(l => {
          const { price, id, sku, product } = l.variant || {};
          const productId = product?.id ?? id;
          return {
            parentId: String(productId),
            uid: String(id),
            qty: l.quantity,
            price: Number(price) || 0,
            ...(sku && { sku }),
          };
        });

        const cart = results;

        if (results.length > 0) {
          await app.$search.callBeacon2Api("cart", "add", {
            results,
            cart,
          });
        }
      } catch (err) {
        console.error("Error in basket view tracking:", err);
        app.$bugsnag.notify(err);
      }
    },
  });
}
